<template>
  <div class="tp_review">
    <review-banner
      type="trustpilot"
      :reviews="trustpilotReviews"
      :show-stars="false"
    />
  </div>
</template>

<script setup>
import ReviewBanner from "~/components/banners/ReviewBanner.vue";
const trustpilotReviews = ref(0);
const fetchData = async () => {
  try {
    const { data: response } = await useApiPost("/api/get-trustpilot-stats", {
      method: "post",
      body: {
        locale: getLocale(),
      },
      lazy: true,
    });
    if (response) {
      trustpilotReviews.value = response?.stats?.number_of_reviews || 0;
    }
  } catch (error) {
    console.log(error);
  }
};
fetchData();
</script>
